import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';

import { useCheckoutContext } from '../../../../state/CheckoutContext';
import {
  postRemovePromoCode,
  togglePromoCodeInputVisibility
} from '../../../../state/Checkout.actions';

import styles from '../Footer.scss';

const PromoButton = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    packageIds,
    promoCodeInputVisibility: isPromoCodeInputVisible,
    products,
    duration
  } = checkoutEntityState;
  const promotionApplied = !!products?.promotion?.code;

  const handleToggleShowPromoCodeInput = () => {
    dispatch(togglePromoCodeInputVisibility());
  };

  const handlePostRemovePromoCode = () => {
    const formData = {
      package_ids: packageIds,
      recurring: duration
    };

    postRemovePromoCode(formData, dispatch);
  };

  if (isPromoCodeInputVisible) {
    return null;
  }
  if (promotionApplied) {
    return (
      <>
        <button
          className={clsx('btn', 'btn-link', styles.actionButton)}
          onClick={handlePostRemovePromoCode}
          type="button"
        >
          {I18n.t(
            'strava.subscriptions.checkout.summary.organic.promo_code.cta.remove'
          )}
        </button>
        <span className={styles.actionDivider}>·</span>
      </>
    );
  }
  return (
    <>
      <button
        className={clsx('btn', 'btn-link', styles.actionButton)}
        onClick={handleToggleShowPromoCodeInput}
        type="button"
      >
        {I18n.t(
          'strava.subscriptions.checkout.summary.organic.promo_code.cta.enter'
        )}
      </button>
      <span className={styles.actionDivider}>·</span>
    </>
  );
};

export default PromoButton;
